import React from 'react';

/**
 * What Amazon SES reported for an email after accepting it, as the backend's
 * queued_emails.delivery_status values. "Delivered" means the receiving mail
 * server accepted it; inbox or spam, no sender can see.
 */
export const DELIVERY_STATUSES = {
	accepted: { label: 'Accepted by SES', className: 'bg-info' },
	delayed: { label: 'Delayed', className: 'bg-warning' },
	delivered: { label: 'Delivered', className: 'bg-success' },
	rejected: { label: 'Rejected by SES', className: 'bg-danger' },
	rendering_failed: { label: 'Rendering failed', className: 'bg-danger' },
	bounced: { label: 'Bounced', className: 'bg-danger' },
	complained: { label: 'Complained', className: 'bg-dark' },
};

/**
 * The SES outcome as a badge, or a dash while SES has not reported on the email.
 */
const DeliveryBadge = ({ status, testId }) => {
	if (!status) {
		return (
			<span className="text-muted" title="No report from SES yet" data-testid={testId}>
				—
			</span>
		);
	}

	const { label, className } = DELIVERY_STATUSES[status] || {
		label: status,
		className: 'bg-secondary',
	};

	return (
		<span className={`badge ${className}`} data-testid={testId}>
			{label}
		</span>
	);
};

export default DeliveryBadge;
